import createReactComponent from '../createReactComponent';
var Grab = createReactComponent('Grab', [['path', {
  d: 'M18 11.5V9a2 2 0 00-2-2v0a2 2 0 00-2 2v1.4',
  key: '17x3aj'
}], ['path', {
  d: 'M14 10V8a2 2 0 00-2-2v0a2 2 0 00-2 2v2',
  key: 'jpalea'
}], ['path', {
  d: 'M10 9.9V9a2 2 0 00-2-2v0a2 2 0 00-2 2v5',
  key: '1ck22g'
}], ['path', {
  d: 'M6 14v0a2 2 0 00-2-2v0a2 2 0 00-2 2v0',
  key: 'qz5owf'
}], ['path', {
  d: 'M18 11v0a2 2 0 114 0v3a8 8 0 01-8 8h-4a8 8 0 01-8-8 2 2 0 114 0',
  key: 'lq4b34'
}]]);
export default Grab;